import { render, staticRenderFns } from "./shop-transactions.vue?vue&type=template&id=170f9788&scoped=true"
import script from "./shop-transactions.vue?vue&type=script&lang=js"
export * from "./shop-transactions.vue?vue&type=script&lang=js"
import style0 from "./shop-transactions.vue?vue&type=style&index=0&id=170f9788&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170f9788",
  null
  
)

export default component.exports